import { kebabCase } from 'change-case'

import { Product } from '../types/product'
import { WorkspaceProduct } from '../types/workspaceProduct'
import { productsLogos } from './productsLogos'
import { ProductConfig, ProductParams } from './types'

export const getProductWithConfig = (
  workspaceProduct: WorkspaceProduct,
): ProductParams & WorkspaceProduct => ({
  ...workspaceProduct,
  ...productsConfig[workspaceProduct.product],
})

const composeProductLearnMoreUrl = (product: Product): string =>
  `https://knowledge-base.yieldbird.com/${kebabCase(product)}`

const productsConfig: ProductConfig = {
  prebidStack: {
    learnMoreUrl: composeProductLearnMoreUrl('prebidStack'),
    logo: productsLogos.prebidStack,
  },
  priceGenius: {
    learnMoreUrl: composeProductLearnMoreUrl('priceGenius'),
    logo: productsLogos.priceGenius,
  },
  refresher: {
    learnMoreUrl: composeProductLearnMoreUrl('refresher'),
    logo: productsLogos.refresher,
  },
  richPlacements: {
    learnMoreUrl: 'https://knowledge-base.yieldbird.com/special-ad-slots',
    logo: productsLogos.richPlacements,
  },
  unfilledRecovery: {
    learnMoreUrl: composeProductLearnMoreUrl('unfilledRecovery'),
    logo: productsLogos.unfilledRecovery,
  },
  viewabilityTools: {
    learnMoreUrl: composeProductLearnMoreUrl('viewabilityTools'),
    logo: productsLogos.viewabilityTools,
  },
} as const
